import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { PointsNumberService } from '@rd/core/services/points-number/points-number.service';
import { RoundMode } from '@rd/types/round-mode.type';

@Pipe({
  name: 'localizePointsNumber',
  pure: true,
  standalone: false,
})
export class LocalizePointsNumberPipe implements PipeTransform {
  constructor(private pointsNumberService: PointsNumberService) {}

  public transform(
    value: number,
    digitsInfo?: string,
    roundDigits?: number,
    roundMode?: RoundMode,
  ): string {
    return this.pointsNumberService.roundNumber(
      value,
      digitsInfo,
      roundDigits,
      roundMode,
    );
  }
}

@NgModule({
  declarations: [LocalizePointsNumberPipe],
  exports: [LocalizePointsNumberPipe],
})
export class LocalizePointsNumberPipeModule {}
